export const LANGUAGES = ['en', 'es'] as const

export type Language = (typeof LANGUAGES)[number]

export const FALLBACK_LANGUAGE: Language = 'en'

// Where the driver portal keeps an explicit language choice. The driver app
// seeds it before the portal loads in its WebView (`OO-45`).
export const DRIVER_PORTAL_LOCALE_STORAGE_KEY = 'dp_locale'

// Lives next to LANGUAGES because that is the only place that knows the set.
// Every locale boundary (browser tags, persisted prefs, device locale) narrows
// through this rather than re-deriving the predicate.
export const isLanguage = (value: unknown): value is Language =>
  typeof value === 'string' && (LANGUAGES as readonly string[]).includes(value)

export const toLanguage = (value: unknown): Language =>
  isLanguage(value) ? value : FALLBACK_LANGUAGE

/**
 * The first supported language among a browser's preferred tags
 * (`navigator.languages`), by base subtag: `es-MX` and `es-419` are `es`.
 */
export const languageFromTags = (tags: readonly (string | undefined)[]): Language => {
  for (const tag of tags) {
    const base = tag?.split('-')[0]?.toLowerCase()
    if (isLanguage(base)) return base
  }
  return FALLBACK_LANGUAGE
}

export const LANGUAGE_LABELS: Record<Language, { label: string }> = {
  en: {
    label: 'English',
  },
  es: {
    label: 'Español',
  },
}
